import { RouteComponentProps } from '@reach/router';
import { getDelegatedOrCurrentCompanyId } from 'app/dux/session/selectors';
import React, { Component, ReactElement } from 'react';
import { AppState } from 'app/store/reducers';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({ companyId: getDelegatedOrCurrentCompanyId(state) });

interface Props extends RouteComponentProps {
    children: ReactElement;
    companyId: string;
}

/**
 * Ensure content is reloaded when the company changes.
 */
class CompanyContainer extends Component<Props> {
    render() {
        // Using the `key=` prop in an array causes React to dismount a component whenever
        // that key changes.

        // Now, we could have wrapped this child in a <div> and applied the `key=` prop to it,
        // but I kinda don't want to create any more <div>s than I have to, so instead I'm using
        // React.cloneElement() to apply it to the existing child.

        return <>{[ React.cloneElement(this.props.children, { key: this.props.companyId }) ]}</>;
    }
}

export default connect(mapStateToProps)(CompanyContainer);
